import { useState, useEffect } from 'react';
import UnityService from '../service/unity';

export function useGetUnity() {
  const [unities, setUnities] = useState([]);

  useEffect(() => {
    UnityService.getAll()
      .then((response) => {
        setUnities(response.data.data);
      })
      .catch((err) => {
        console.log('err: ' + err);
      });
  }, []);

  return {
    unities,
    setUnities
  };
}
